export const MajorAnimationDurationTypes = [
    'anim-sec-10',
    'anim-sec-20',
    'anim-sec-30',
]

export const MinorAnimationDurationTypes = [
    'anim-sec-1',
    'anim-sec-2',
    'anim-sec-3',
    'anim-sec-4',
]